gsap.registerPlugin(ScrollTrigger, SplitText);

// Sélectionner tous les éléments avec la classe 'split'
document.querySelectorAll('.split').forEach(splitElement => {
    var split = new SplitText(splitElement, { type: "words" });

    // Récupérer la valeur de l'origine à partir du dataset
    let originY = splitElement.dataset.origin ? parseInt(splitElement.dataset.origin) : 0;

    // Créer une animation pour les mots
    gsap.from(split.words, {
        duration: 0.5,
        autoAlpha: 0,
        stagger: 0.025,
        scrollTrigger: {
            trigger: splitElement,
            start: "top center", 
            end: "bottom bottom",
            // scrub: true,
            // toggleActions: "play none none reverse",
            // markers: true // À enlever en production
        }
    });

    gsap.fromTo(splitElement, {
        y: originY, // Utiliser la valeur de l'origine pour l'animation initiale
        scrollTrigger: {
            trigger: splitElement,
            start: "top center", 
            end: "bottom center", 
            // scrub: true,
            // markers: true // À enlever en production
        }
    },
    {
        y: -ScrollTrigger.maxScroll(window) * splitElement.dataset.speed / 100,
        scrollTrigger: {
            trigger: splitElement,
            start: "top center", 
            end: "bottom center",
            // scrub: true,
            // markers: true // À enlever en production
        }
    }
    );

});

// Sélectionner tous les éléments avec la classe 'split'
document.querySelectorAll('.split1').forEach(splitElement => {
    var split = new SplitText(splitElement, { type: "words" });

    // Récupérer la valeur de l'origine à partir du dataset
    let originY = splitElement.dataset.origin ? parseInt(splitElement.dataset.origin) : 0;

    // Créer une animation pour les mots
    gsap.from(split.words, {
        duration: 0.5,
        autoAlpha: 0,
        stagger: 0.025,
        scrollTrigger: {
            trigger: splitElement,
            start: "top bottom", 
            end: "bottom bottom",
            // scrub: true,
            // toggleActions: "play none none reverse",
            // markers: true // À enlever en production
        }
    });

    gsap.fromTo(splitElement, {
        y: originY, // Utiliser la valeur de l'origine pour l'animation initiale
        scrollTrigger: {
            trigger: splitElement,
            start: "top bottom", 
            end: "bottom center", 
            // scrub: true,
            // markers: true // À enlever en production
        }
    },
    {
        y: -ScrollTrigger.maxScroll(window) * splitElement.dataset.speed / 100,
        scrollTrigger: {
            trigger: splitElement,
            start: "top bottom", 
            end: "bottom center",
            // scrub: true,
            // markers: true // À enlever en production
        }
    }
    );

});
